<template>
  <uiList
    :items="chats"
    :background="false"
    width="auto"
    :fixed="false"
    :border="false"
    @click="selectChat"
  >
    <template v-slot:item="{ item }">
      <div class="chat" :class="{ selected: isSelected(item.id) }">
        <div class="avatar">
          <uiImage
            v-if="item.client.avatar"
            :url="item.client.avatar"
            radius-class="rounded-full"
          />

          <div class="circle" :style="{ background: item.color }" v-else>
            {{ item.client.name.slice(0, 1) }}
          </div>
        </div>
        <div class="info">
          <div class="name">{{ getFullname(item.client) }}</div>

          <Icon
            v-if="typingUsers.includes(item.client.id)"
            icon="svg-spinners:3-dots-scale"
            width="16"
            class="text-gray-400"
          />
          <div v-else class="preview">{{ getPreview(item) }}</div>
        </div>
      </div>
    </template>
  </uiList>
</template>

<script>
import { getFullname } from '@/utils/name'

export default {
  name: 'ChatList',
  props: {
    selected: String
  },
  computed: {
    chats () {
      return this.$store.getters.chats.reverse()
    },
    typingUsers () {
      return this.$store.getters.typingUsers
    },
  },
  methods: {
    selectChat (e) {
      if (this.selected === e.id) return
      let chat = this.chats.find(c => c.id === e.id)
      if (!chat) return
      this.$emit('select', chat)
    },
    isSelected (id) {
      return this.selected === id
    },
    getFullname,
    getPreview(chat) {
      return chat.messages.at(-1)?.text ?? 'Новое сообщение'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';
.chat {
  display: flex;
  align-items: center;
  border-radius: 16px;
  padding: 10px;
  position: relative;

  &.selected {
    background: @grey;
  }

  .avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;

    .circle {
      line-height: 40px;
      text-align: center;
      font-size: 24px;
      color: #fff;
      font-weight: bold;
      border-radius: 50%;
    }
  }

  .info {
    margin: 0 10px;
    min-width: 0;
  }

  .name {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .preview {
    flex: 1;
    font-size: 13px;
    opacity: 0.5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
